import Model from "./Model";

export default class Allotment extends Model {
  resource() {
    return "allotments";
  }
}
